<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="dummyExitMovementItems"
    :indexNested="true"
    :maskFields="maskFields"
    :disablePagination="true"
    :containTopToolbar="false"
    :hasTableTitle="true"
  >

  </BaseIndex>
</template>

<script>
import BaseIndex from "@shared_components/base_index.vue";

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      installmentHrefType: null,
      indexKey: 1,
      tableHeaders: [
        // { text: "#", align: "left", sortable: true, value: "code" },
        { text: "Nome", align: "left", sortable: true, value: "item.name" },
        { text: "Embalagem", align: "left", sortable: true, value: "packaging.name" },
        { text: "Quantidade", align: "left", sortable: true, value: "packagingQuantity" },
        { text: "R$", align: "left", sortable: true, value: "price" },
        // { text: "Data", align: "left", sortable: true, value: "dueDate" },
        // { text: "Status", align: "left", sortable: true, value: "status" },
        // { text: "Ações", value: "action", sortable: false },
        // { text: "deleted", value: "_destroy", align: ' d-none', sortable: false, filter: value => value ? !value : true},
      ],
      maskFields: [
        { field: 'price', mask: 'currency' },
        // { field: 'dueDate', mask: 'date' },
        // { field: 'totalPaidAmount', mask: 'currency' },
        // { field: 'paymentDate', mask: 'date' },
        // { field: 'status', mask: 'status_color', colorField: 'statusColor' },
      ]
    };
  },
  components: {
    BaseIndex: BaseIndex,     
  },
  beforeCreate: function () {    
  },
  props: {
    dummyExitMovementItems: {
      type: Array,
      default: []
    },    
    readOnly: {
      type: Boolean,
      default: false
    },
    modelType: {
      type: String,
    },
    modelNameSingular: {
      type: String,
      default: "Poduto"
    },
    modelNamePlural: {
      type: String,
      default: "Produtos"
    },
  },
  created() {
    
  },
  methods: {
    
  }
};
</script>

<style scoped></style>
